import React from 'react';
import './HeaderLogin.css';

export default function HeaderLogin() {
  return (
    <div className="header-login-mob">
        <h1 className="heading-login-mob">Feedback</h1>
        <p className="content-login-mob">Add your products and give us your valuable feedback</p>
    </div>
  )
}
